import { listLayers } from './list-layers';
import { describeLayer } from './describe-layer';
import { refreshLayerMetadataTool } from './refresh-layer-metadata';
import { resolvePlace } from './resolve-place';
import { resolveFeatures } from './resolve-features';
import { getSelection } from './get-selection';
import { describe } from './describe';
import { computeBuffer } from './compute-buffer';
import { computeIntersection } from './compute-intersection';
import { computeUnion } from './compute-union';
import { computeDifference } from './compute-difference';
import { computeExtent } from './compute-extent';
import { computeCentroid } from './compute-centroid';
import { computeDistance } from './compute-distance';
import { drawDistance } from './draw-distance';
import { computeShortestPath } from './compute-shortest-path';
import { query } from './query';
import { queryNearest } from './query-nearest';
import { spatialJoin } from './spatial-join';
import { identifyAtPoint } from './identify-at-point';
import { viewState } from './view-state';
import { viewZoomTo } from './view-zoom-to';
import { viewSetBasemap } from './view-set-basemap';
import { viewToggleLayer } from './view-toggle-layer';
import { layerSetFilter } from './layer-set-filter';
import { layerClassify } from './layer-classify';
import { layerSetClassColor } from './layer-set-class-color';
import { layerPaintByValue } from './layer-paint-by-value';
import { layerResetSymbology } from './layer-reset-symbology';
import { render } from './render';
import { renderClear } from './render-clear';
import { renderUndo } from './render-undo';
import { chart } from './chart';
import { sketchTool } from './sketch';
import { measure } from './measure';
import { printMap } from './print-map';
import { exportFeatures } from './export-features';
import { bookmarkSave } from './bookmark-save';
import { bookmarkGo } from './bookmark-go';
import { bookmarkList } from './bookmark-list';
import type { AnyTool, Tool } from './types';

export const PRIMITIVE_TOOLS: AnyTool[] = [
  listLayers,
  describeLayer,
  refreshLayerMetadataTool,
  resolvePlace,
  resolveFeatures,
  getSelection,
  describe,
  computeBuffer,
  computeIntersection,
  computeUnion,
  computeDifference,
  computeExtent,
  computeCentroid,
  computeDistance,
  drawDistance,
  computeShortestPath,
  query,
  queryNearest,
  spatialJoin,
  identifyAtPoint,
  viewState,
  viewZoomTo,
  viewSetBasemap,
  viewToggleLayer,
  layerSetFilter,
  layerClassify,
  layerSetClassColor,
  layerPaintByValue,
  layerResetSymbology,
  render,
  renderClear,
  renderUndo,
  chart,
  sketchTool,
  measure,
  printMap,
  exportFeatures,
  bookmarkSave,
  bookmarkGo,
  bookmarkList,
] as Tool<unknown, unknown>[];

export type { Tool, AnyTool, ToolInputSchema } from './types';
